import { adminSearchShardCatalogDetailsGetSlice } from './get';

export * from './default/actions';

export const {
	requestGetAdminSearchShardCatalogDetails,
	resetGetAdminSearchShardCatalogDetails
} = adminSearchShardCatalogDetailsGetSlice.asyncActionCreators;
